import React, { Component } from 'react';
import { connect } from 'react-redux';
import './styles.css';
import { Auth } from 'aws-amplify';
import axios from 'axios';
import { uniqueDmps } from '../../lib/format-dmps';
import UserRolesService from '../../lib/services/userRole/UserRolesService';
import SessionService from '../../lib/services/SessionService';

class SignIn extends Component {
  email = undefined;
  password = undefined;
  newPassword = undefined; // for password confirmation
  errorMessage = null;
  state = {
    phase: 0,
    userAttributes: null,
    errorMessage: null,
    username: null,
    cognitoUser: null,
    disabled: true,
    changePasswordDisabled: true,
    loading: false,
  };

  componentDidMount() {}

  // load additional data when reloading / after checking if user is signed in...
  getPartnerData() {
    Auth.currentAuthenticatedUser({
      bypassCache: false, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
    })
      .then((user) => {
        console.log('amplify auth user', user);

        // refresh the current roles for this user
        new UserRolesService().updateUserRoles().then((roles) => {
          axios.get('/partner').then((response) => {
            console.log('getPartnerData promise response ', response);
            SessionService.setPartnerLogged(
              response.data.body[0].partnerSettings || {}
            );

            axios.get('/dmpDetails').then((response) => {
              console.log('getPartnerData dmp details', response);
              window.localStorage.dmpsDetails = JSON.stringify(
                response.data.body || []
              );
              window.localStorage.dmps = JSON.stringify(
                uniqueDmps(response.data.body) || []
              );

              this.setState({ loading: false });

              // then redirect to home
              window.location.href = '/';
            });
          });
        });
      })
      .catch((err) => {
        console.log('amplify auth user error:', err);
      });
  }

  onSignIn() {
    this.setState({ errorMessage: null, loading: true }, () => {
      const username = this.email.value.trim();
      const password = this.password.value.trim();
      SessionService.setUsernameLogged(username);

      let self = this;

      //console.warn(`Signing in with [${username}, ${password}]`)

      Auth.signIn(username, password)
        .then((user) => {
          //console.log('sign in response', user)

          if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
            const { userAttributes, requiredAttributes } = user.challengeParam; // the array of required attributes, e.g ['email', 'phone_number']
            delete userAttributes.email_verified;
            self.setState({
              phase: 1,
              cognitoUser: user,
              userAttrubutes: userAttributes,
              username: username,
              errorMessage: null,
              loading: false,
              changePasswordDisabled: false,
            });
          } else {
            // login successful

            Auth.currentSession()
              .then((data) => {
                //console.log('get cognito session:', data)
                let session = data;

                //set token for all AXIOS REQUESTS
                axios.defaults.headers.common['Authentication'] =
                  session.idToken.jwtToken;

                let partnerMasquerading = SessionService.getPartnerMasqueraded();
                if (
                  partnerMasquerading != null &&
                  partnerMasquerading.partnerId
                ) {
                  axios.defaults.headers.common['PartnerIdMasquerading'] =
                    partnerMasquerading.partnerId;
                }
                this.getPartnerData();
              })
              .catch((err) => {
                console.log('get cognito session error:', err);
                self.setState({ errorMessage: err, loading: false });
              });
          }
        })
        .catch((err) => {
          console.error('sign in error', err);
          self.setState({ errorMessage: err, loading: false });
        });
    });
  }
  changePassword() {
    this.setState(
      { errorMessage: null, loading: false, changePasswordDisabled: false },
      () => {
        let self = this;
        console.log('changePass', this.state);
        this.state.cognitoUser.completeNewPasswordChallenge(
          this.newPassword.value,
          this.state.userAttributes,
          {
            onSuccess: function(result) {
              //resolve(result)
              window.location.href = '/';
            },
            onFailure: function(err) {
              //reject(err)
              console.error(err);
              self.setState({ errorMessage: err });
            },
          }
        );
      }
    );
  }

  checkOnChange(event) {
    this.setState({ disabled: true });
    if (
      this.email &&
      this.email.value !== '' &&
      this.password &&
      this.password.value !== ''
    ) {
      this.setState({ disabled: false });
    }
  }

  checkPasswordChange(event) {
    this.setState({ changePasswordDisabled: true });
    if (this.newPassword && this.newPassword.value !== '') {
      this.setState({ changePasswordDisabled: false });
    }
  }

  render() {
    return (
      <div className='login-register-wrapper'>
        <div className='login-register'>
          <div className='login-register picture' />
          <div className='login-box login-sidebar'>
            <img
              className='ar-logo'
              src='/img/audiencerate-logo.png'
              alt='Audience Rate'
            />

            {this.state.phase === 0 && (
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.onSignIn();
                }}
              >
                <div>
                  <div className='login-input-wrapper email-wrapper'>
                    <input
                      disabled={this.state.loading}
                      id='login'
                      placeholder='Email'
                      ref={(node) => (this.email = node)}
                      onChange={(e) => this.checkOnChange(e)}
                    />
                  </div>
                  <div className='login-input-wrapper'>
                    <input
                      disabled={this.state.loading}
                      id='password'
                      type='password'
                      placeholder='Password'
                      ref={(node) => (this.password = node)}
                      onChange={(e) => this.checkOnChange(e)}
                    />
                  </div>
                  <div className='login-link-wrapper'>
                    <a
                      id='lost-password'
                      href='/forgot-password'
                      style={{ float: 'right' }}
                    >
                      <i className='fa fa-lock' style={{ marginRight: 8 }} />
                      &#160;Lost password?
                    </a>
                  </div>

                  <div className='login-input-wrapper'>
                    <button
                      type='submit'
                      disabled={this.state.disabled}
                      id='sign-up'
                      onClick={() => this.onSignIn()}
                    >
                      Log in
                    </button>
                  </div>
                </div>
              </form>
            )}

            {this.state.phase === 1 && (
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.changePassword();
                }}
              >
                <div>
                  <div className='login-input-wrapper'>
                    <input
                      disabled={this.state.loading}
                      id='newPassword'
                      type='password'
                      placeholder='Change Password'
                      ref={(node) => (this.newPassword = node)}
                      onChange={(e) => this.checkPasswordChange(e)}
                    />
                    <span className='info'>
                      Password must have a minimum of 8 characters with almost
                      one uppercase character, one lowercase character, one
                      number and one symbol.
                    </span>
                  </div>
                  <div className='login-input-wrapper'>
                    <button
                      type='submit'
                      disabled={this.state.changePasswordDisabled}
                      id='sign-up'
                      onClick={() => this.changePassword()}
                    >
                      Change Password
                    </button>
                  </div>
                </div>
              </form>
            )}

            {this.state.loading && (
              <div className='login-loading-wrapper'>
                <i className='fa fa-spin fa-spinner' />
              </div>
            )}

            {!this.state.loading &&
              this.state.errorMessage &&
              this.state.errorMessage.message && (
                <div className='login-error-wrapper'>
                  {this.state.errorMessage.message}
                </div>
              )}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({}),
  {}
)(SignIn);
